const levels = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3
};

const currentLevel = process.env.VUE_APP_LOG_LEVEL ? process.env.VUE_APP_LOG_LEVEL.trim() : 'info';

const shouldLog = (level) => {
    const currentPriority = levels[currentLevel] !== undefined ? levels[currentLevel] : levels.info;
    const levelPriority = levels[level];

    // Logic: if currentLevel is 'info' (2), we show error(0), warn(1), info(2).
    return levelPriority <= currentPriority;
};

const getTimestamp = () => {
    return new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
};

const logger = {
    error: (...args) => {
        if (shouldLog('error')) console.error(`[${getTimestamp()}] [ERROR]`, ...args);
    },
    warn: (...args) => {
        if (shouldLog('warn')) console.warn(`[${getTimestamp()}] [WARN]`, ...args);
    },
    info: (...args) => {
        if (shouldLog('info')) console.log(`[${getTimestamp()}] [INFO]`, ...args);
    },
    debug: (...args) => {
        if (shouldLog('debug')) console.log(`[${getTimestamp()}] [DEBUG]`, ...args);
    }
};

export default logger;
